import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=73126184&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.styl?vue&type=style&index=0&id=73126184&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73126184",
  null
  
)

export default component.exports